import { useRef, useEffect } from "react";
 
const InputField = ({
  label,
  type = "text",
  value,
  name,
  onChange,
  onBlur,
  placeholder,
  error,
  styleTextarea = {},
  styleInput = {},
  clsname,
  inpcls = "",
  disabled = false,
  readOnly = false,
  required = false,
}) => {
  const safeValue = value ?? "";
  const isTextArea = type === "textarea";
  const textAreaRef = useRef(null);
 
  useEffect(() => {
    if (isTextArea && textAreaRef.current) {
      textAreaRef.current.style.minHeight = "auto";
      textAreaRef.current.style.minHeight = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [safeValue, isTextArea]);
 
  return (
    <div className="mb-2">
      {label && (
        <label className={`form-label ${clsname}`}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
 
      {isTextArea ? (
        <textarea
          className={`form-control ${inpcls} ${error ? "is-invalid" : ""}`}
          value={safeValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          style={styleTextarea}
        />
      ) : (
        <input
          type={type}
          className={`form-control ${inpcls} ${error ? "is-invalid" : ""}`}
          value={safeValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          style={styleInput}
        />
      )}
 
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};
 
export default InputField;
 